import { render, staticRenderFns } from "./ListSkeleton.vue?vue&type=template&id=157ed3f4&"
import script from "./ListSkeleton.vue?vue&type=script&lang=js&"
export * from "./ListSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QSkeleton,QItemLabel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList,QItem,QItemSection,QSkeleton,QItemLabel})
